import { render, staticRenderFns } from "./FilterSelect.vue?vue&type=template&id=0ddc4f50&"
import script from "./FilterSelect.vue?vue&type=script&lang=ts&"
export * from "./FilterSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ddc4f50')) {
      api.createRecord('0ddc4f50', component.options)
    } else {
      api.reload('0ddc4f50', component.options)
    }
    module.hot.accept("./FilterSelect.vue?vue&type=template&id=0ddc4f50&", function () {
      api.rerender('0ddc4f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filters/FilterSelect.vue"
export default component.exports